import * as _types from "../_constants/types";
import ws from "../_constants/webservices";

export const getAuthToken = (ticketId, emailAddress) => dispatch => {
    dispatch({ type: _types.AUTH_TOKEN_FETCHING });

    let url = `/auth/token`;
    let data = JSON.stringify({
        ticket_id: ticketId,
        email_address: emailAddress
    });

    ws.rma.post(url, ws.rma.abortAndGetNewSignal("AUTH_TOKEN_FETCHING"), data).then(
        response => {
            if (response.status === 200) {
                response.json().then(json => {
                    //window.localStorage.setItem("-rma-jwt", json);
                    dispatch({ type: _types.AUTH_TOKEN_LOAD, data: json });
                    dispatch({ type: _types.AUTH_TOKEN_FETCHING_COMPLETED });
                });
            } else {
                response.json().then(json => {
                    dispatch({ type: _types.AUTH_TOKEN_FETCHING_FAILED, err: json });
                });
            }
        },
        error => {
            dispatch({ type: _types.AUTH_TOKEN_FETCHING_FAILED, err: error.message });
        }
    );
};

export const setAuthToken = token => dispatch => {
    dispatch({ type: _types.AUTH_TOKEN_LOAD, data: token });
};
